import { APP_VERSION } from '../utils/version'

/**
 * The version tag shown in the footer.
 *
 * This used to resolve Retool's `retoolContext.pageTag`: the app ran inside the
 * classic Retool app's iframe, so the tag arrived either on the iframe URL or
 * over a postMessage broker in the parent frame. Standalone there is no parent
 * frame and no Retool release tag, so the bundled APP_VERSION *is* the version —
 * bump it in utils/version.ts when releasing.
 *
 * Kept as a hook, under its original name, so App.tsx and the footer are
 * unchanged.
 */
export function useRetoolPageTag(): string {
  return APP_VERSION
}
